import React, { useState, useContext, useMemo } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "../Button/Button";
// import "../Form/Createaccountform.css";
import "./AddSignatory.css";

import { MdOutlineFileUpload } from "react-icons/md";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { baseUrl } from "../../config/endpoints";
import { baseUrl2 } from "../../config/endpoints";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import MainContext from "../../context/Main/MainContext";
import { ClipLoader } from "react-spinners";
import { AiTwotoneDelete } from "react-icons/ai";
import { toast } from "react-toastify";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // Initial width
  maxWidth: 900, // Maximum width
  height: "90%",
  bgcolor: "background.paper",
  // border: '2px solid #000',
  overflow: "auto",

  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};
const AddSignatory = ({ setState, state }) => {
  // const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bvnDetails, setBvnDetails] = useState(null);
  const [currentOption, setCurrentOption] = useState(null);
  const [documents, setDocuments] = useState([]);

  const handleOpen = () => setState(true);
  const handleClose = () => setState(false);
  const {
    signatories,
    setSignatories,
    signatoriesDocuments,
    setSignatoriesDocuments,
  } = useContext(MainContext);

  // VALIDATE BVN FUNCTION
  const validateBvn = async (bvn) => {
    const payload = {
      BVN: bvn,
    };

    setIsLoading(true);
    setBvnDetails(null);
    try {
      const response = await axios.post(
        baseUrl2 + "/account/ops/validate_bvn",
        payload
      );
      setFieldValue("lastName", response?.data?.vLastName);
      setFieldValue("firstName", response?.data?.vFirstName);
      setFieldValue("middleName", response?.data?.vMiddleName);
      setBvnDetails(response.data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBvnBlur = async (e) => {
    if (values?.directorBVN?.length === 11) {
      await validateBvn(values?.directorBVN);
    }
  };
  const handleOptionChange = (e) => {
    setCurrentOption(e?.target?.value);
  };
  const handleFileUpload = (e) => {
    e.preventDefault();
    const selectedFile = e?.target?.files;
    if (!selectedFile) {
      return;
    }
    const isDocumentAlreadyUploaded = documents.find(
      (doc) => doc.id === currentOption?.id
    );

    if (isDocumentAlreadyUploaded) {
      return;
    }

    const parsedOption = JSON.parse(currentOption);
    const currentFileObject = { ...parsedOption, file: selectedFile };

    setDocuments((documents) => {
      const newDocument = [...documents, currentFileObject];
      return newDocument;
    });
    setCurrentOption(null);
  };

  const fileOptionsByAccount = [
    {
      id: 1,
      fileName: "valid-id-card",
      display: "Valid ID Card",
    },
    {
      id: 2,
      fileName: "passport",
      display: "Passport",
    },
    {
      id: 3,
      fileName: "signature",
      display: "Signature",
    },
  ];

  const initialFieldValues = {
    phone: "",
    directorBVN: "",
    email: "",
    currentAddress: "",
    religion: "",
    motherMaidenName: "",
    stateOfOrigin: "",
    occupation: "",
    isDirector: false,
    isSignatory: false,
    hasAuthority: "",
    idNumber: "",
    issueDate: "",
    expiryDate: "",
    nin: "",
    idType: "",
    firstName: "",
    lastName: "",
    middleName: "",
  };
  const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validationSchema = Yup.lazy((values) => {
    return Yup.object().shape({
      directorBVN: Yup.string()
        .required("BVN is required")
        .length(11, "BVN should be 11 characters long"),
      currentAddress: Yup.string().required("Address is required"),
      email: Yup.string()
        .matches(emailValidationRegex, "Invalid email address")
        .required("Email is required"),
      motherMaidenName: Yup.string().required("Mother maiden name is required"),
      idType: Yup.string().required("Type is required"),
      idNumber: Yup.string().required("idNumber is required"),
      phone: Yup.string()
        .required("Phone number is required")
        .min(11, "Phone number should be at least 11 digits")
        .max(16, "Phone number should not exceed 16 digits"),
      issueDate: Yup.date(),
      expiryDate: Yup.date().min(
        Yup.ref("issueDate"),
        "Expiry date must be after issue date"
      ),
      isDirector: Yup.boolean(),
      isSignatory: Yup.boolean(),
    });
  });

  const {
    values,
    errors: formikErrors,
    setFieldValue,
    touched,
    handleSubmit: formikHandleSubmit,
    handleChange,
    isSubmitting,
  } = useFormik({
    initialValues: initialFieldValues,
    validationSchema: validationSchema,
    onSubmit: async (value, { resetForm }) => {
      if (bvnDetails.ResponseCode === "01") {
        toast.error("Please provide a valid bvn to continue",)
        // Swal.fire({
        //   title: "Bvn Invalid",
        //   text: "Please provide a valid bvn to continue",
        //   icon: "error",
        // });
        return;
      }
      const newItem = {
        ...value,
        id: signatories?.length + 1,
        document: documents,
      };
      const newDocument = { ...documents };

      const itExists = signatories.some(
        (obj) => obj?.directorBVN === values?.directorBVN
      );

      if (itExists) {
        toast.error("Bvn has already been added");
        resetForm();
        handleClose();
        return;
      }
      if (values.isDirector === false && values.isSignatory === false) {
        toast.error("Individual has to be a Director or Signatory");
        return;
      }
      if (documents.length < 3) {
        toast.error("Documents should be complete");
        return;
      }

      setSignatories((prevItem) => [...prevItem, newItem]);
      setSignatoriesDocuments((prevItem) => [...prevItem, newDocument]);

      resetForm();
      setDocuments([]);
      handleClose();
    },
  });
  const handleNumericInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    const { name } = e.target;
    setFieldValue(name, value);
    if (name === "directorBVN") {
      setBvnDetails(null);
    }
  };

  const availableOptions = useMemo(() => {
    const documentsSelected = documents.reduce((a, b) => {
      a.push(b?.fileName);
      return a;
    }, []);
    return fileOptionsByAccount.filter(
      (option) => !documentsSelected.includes(option?.fileName)
    );
  }, [documents]);
  const handleDelete = (id) => {
    setDocuments((documents) => documents.filter((doc) => doc?.id !== id));
  };
  return (
    <div>
      <Modal
        open={state}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="keep-mounted-modal-title"
            variant="h5"
            component="h1"
            style={{ fontWeight: "bold" }}
          >
            Add Signatory
          </Typography>
          <div>
            <form className="w-auto" onSubmit={formikHandleSubmit}>
              <div className="input-group-signatory">
                <div className="input-container-signatory">
                  <label> BVN</label>
                  <input
                    className="input-signatory"
                    name="directorBVN"
                    value={values?.directorBVN}
                    onChange={handleNumericInputChange}
                    placeholder="22222222222"
                    onBlur={handleBvnBlur}
                  />
                  {isLoading ? (
                    <div>
                      <ClipLoader color="#FFB200" size={18} /> ...validating{" "}
                    </div>
                  ) : (
                    ""
                  )}

                  {bvnDetails ? (
                    <div>
                      {" "}
                      {bvnDetails?.ResponseCode === "00" ? (
                        <p className="success_text">
                          {bvnDetails.vFirstName +
                            " " +
                            bvnDetails.vMiddleName +
                            " " +
                            bvnDetails.vLastName}
                        </p>
                      ) : bvnDetails?.ResponseCode !== "00" ? (
                        <p className="error_text">Invalid bvn</p>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : null}

                  {touched?.directorBVN && formikErrors?.directorBVN ? (
                    <p className="error">{formikErrors?.directorBVN}</p>
                  ) : null}
                </div>
                <div className="input-container-signatory">
                  <label>Occupation</label>
                  <input
                    className="input-signatory"
                    type="text"
                    name="occupation"
                    id="occupationn"
                    value={values?.occupation}
                    onChange={handleChange}
                  />
                </div>
                <div className="input-container-signatory">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="input-signatory"
                    placeholder="example@example.com"
                    required={false}
                    value={values?.email}
                    onChange={handleChange}
                  />
                  {touched?.email && formikErrors?.email ? (
                    <p className="error">{formikErrors?.email}</p>
                  ) : null}
                </div>
              </div>
              <div className="input-group-signatory">
                <div className="input-container-signatory">
                  <label>Religion</label>
                  <select
                    className="input-signatory"
                    type="string"
                    name="religion"
                    id="religion"
                    value={values?.religion}
                    onChange={handleChange}
                  >
                    <option>Select your Religion</option>
                    <option value="1">Christianity</option>
                    <option value="2">Islam</option>
                    <option value="4">Hindu</option>
                    <option value="3">Others</option>
                  </select>

                  {touched?.religion && formikErrors?.religion ? (
                    <p className="error">{formikErrors.religion}</p>
                  ) : null}
                </div>
                <div className="input-container-signatory">
                  <label>Phone Number</label>
                  <input
                    className="input-signatory"
                    name="phone"
                    id="phone"
                    value={values?.phone}
                    onChange={handleNumericInputChange}
                    placeholder="1234567890"
                  />

                  {touched?.phone && formikErrors?.phone ? (
                    <p className="error">{formikErrors?.phone}</p>
                  ) : null}
                </div>
                <div className="input-container-signatory">
                  <label>Mother's Maiden Name</label>

                  <input
                    className="input-signatory"
                    type="string"
                    name="motherMaidenName"
                    value={values?.motherMaidenName}
                    onChange={handleChange}
                  />
                  {touched?.motherMaidenName &&
                  formikErrors?.motherMaidenName ? (
                    <p className="error">{formikErrors?.motherMaidenName}</p>
                  ) : null}
                </div>
              </div>

              <div className="input-group-signatory">
                <div className="input-container-signatory">
                  <label>State Of Origin</label>
                  <input
                    className="input-signatory"
                    type="string"
                    name="stateOfOrigin"
                    id="stateOfOrigin"
                    value={values?.stateOfOrigin}
                    onChange={handleChange}
                    // placeholder="12345678"
                  />
                </div>
                <div className="input-container-signatory">
                  <label>National Identification Number</label>
                  <input
                    className="input-signatory"
                    name="nin"
                    id="nin"
                    value={values?.nin}
                    onChange={handleNumericInputChange}
                    // placeholder="12345678"
                  />
                </div>
              </div>

              <div className="input-address-container">
                <label>Address</label>
                <textarea
                  rows="3"
                  className="address_input"
                  type="text"
                  name="currentAddress"
                  id="currentAddress"
                  value={values?.currentAddress}
                  onChange={handleChange}
                />
                {touched?.currentAddress ? (
                  <p className="error">{formikErrors?.currentAddress}</p>
                ) : null}
              </div>
              <div className="input-group-signatory">
                <div className="input-container-signatory">
                  <label>Type of Identification</label>
                  <select
                    className="input-signatory"
                    type="string"
                    name="idType"
                    value={values?.idType}
                    onChange={handleChange}
                  >
                    <option value="">--Select Type--</option>
                    <option value="NIN">National Identification Number </option>
                    <option value="DL">Driver's License</option>
                    <option value="VC">Voter's Card</option>
                    <option value="IP">International Passport</option>
                  </select>
                  {/* {bvnDetails ?  <div> { bvnDetails?.ResponseCode === "00" ? <p className = "success_text">Bvn validated successfully</p> :<p className="error_text">Invalid bvn</p>}</div> : null} */}
                  {touched?.idType && formikErrors?.idType ? (
                    <p className="error">{formikErrors.idType}</p>
                  ) : null}
                </div>
                <div className="input-container-signatory">
                  <label>ID Number</label>
                  <input
                    className="input-signatory"
                    // type="string"
                    name="idNumber"
                    id="idNumber"
                    value={values?.idNumber}
                    onChange={handleChange}
                    // placeholder="12345678"
                  />
                  {touched?.idNumber && formikErrors?.idNumber ? (
                    <p className="error">{formikErrors.idNumber}</p>
                  ) : null}
                </div>
              </div>
              {values?.idType === "DL" ||
              values?.idType === "IP" ||
              values?.idType === "VC" ? (
                <div className="input-group-signatory">
                  <div className="input-container-signatory">
                    <label>Issued Date</label>
                    <input
                      className="input-signatory"
                      type="date"
                      name="issueDate"
                      value={values?.issueDate}
                      onChange={handleChange}
                    />
                    {touched?.issueDate && formikErrors?.issueDate ? (
                      <p className="error">{formikErrors?.issueDate}</p>
                    ) : null}
                  </div>
                  <div className="input-container-signatory">
                    <label>Expiry Date</label>

                    <input
                      className="input-signatory"
                      type="date"
                      name="expiryDate"
                      id="expiryDate"
                      value={values?.expiryDate}
                      onChange={handleChange}
                    />
                    {touched?.expiryDate && formikErrors?.expiryDate ? (
                      <p className="error">{formikErrors.expiryDate}</p>
                    ) : null}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="file-list-container">
                {documents?.map((doc) => (
                  <div key={doc?.id} className="document_item">
                    <div className="file-name">
                      <strong>{doc?.display}</strong>
                      <span>{doc?.file?.[0]?.name}</span>
                    </div>
                    <button onClick={() => handleDelete(doc?.id)}>
                      <AiTwotoneDelete className="button-icon" />
                    </button>
                  </div>
                ))}
              </div>
              <div className="file_upload">
                <div>
                  <select onChange={handleOptionChange} className="file_select">
                    <option value=""> Select document to upload</option>
                    {availableOptions?.map((availableOption) => {
                      return (
                        <option
                          key={availableOption?.id}
                          value={JSON.stringify(availableOption)}
                        >
                          {availableOption?.display}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="upload">
                  <label htmlFor="available-signatory-option">Upload</label>
                </div>
                <input
                  type="file"
                  id="available-signatory-option"
                  onChange={handleFileUpload}
                  disabled={!currentOption}
                 accept=".pdf, .jpg, .jpeg, .png, .doc, .xlsx, .xlsm, .xlsb"
                />
              </div>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="createaccount_question">
                  <div className="createaccount_answers">
                    <label htmlFor="isDirector">Director</label>
                    <input
                      className="input_radio"
                      type="checkbox"
                      value={values.isDirector}
                      onChange={handleChange}
                      name="isDirector"
                      id="isDirector"
                    />
                    {touched?.isDirector && formikErrors?.isDirector ? (
                      <p className="error">{formikErrors?.isDirector}</p>
                    ) : null}
                  </div>
                  <div className="createaccount_answers">
                    <label htmlFor="isSignatory">Signatory</label>
                    <input
                      type="checkbox"
                      className="input_radio"
                      value={values.isSignatory}
                      name="isSignatory"
                      onChange={handleChange}
                      id="isSignatory"
                    />
                    {touched?.isSignatory && formikErrors?.isSignatory ? (
                      <p className="error">{formikErrors?.isSignatory}</p>
                    ) : null}
                  </div>
                </div>
              </div>
              {values.isDirector === true && (
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div> Authority to Debit Search? </div>
                  <div className="createaccount_question">
                    <div className="createaccount_answers">
                      <label htmlFor="Yes">Yes</label>
                      <input
                        className="input_radio"
                        type="radio"
                        value={true}
                        onChange={handleChange}
                        name="hasAuthority"
                        id="Yes"
                      />
                    </div>
                    <div className="createaccount_answers">
                      <label htmlFor="No">No</label>
                      <input
                        type="radio"
                        className="input_radio"
                        value={false}
                        name="hasAuthority"
                        onChange={handleChange}
                        id="No"
                      />
                    </div>
                    {touched?.hasAuthority && formikErrors?.hasAuthority ? (
                      <p className="error">{formikErrors?.hasAuthority}</p>
                    ) : null}
                  </div>
                </div>
              )}
              <button type="submit" className="button">
                Save
              </button>
            </form>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AddSignatory;
